import * as Yup from 'yup';

export default (yup: typeof Yup) => ({
  license: yup.string().required(),
});
